module.exports = __webpack_public_path__ + "img/excretion.8d75671b.svg";